<template>
  <StepTwoDialog
    openBtnName="重置"
    ref="dialog"
    :stepTitles="verifyWay === 'password' ? [] : ['安全验证', '输入新密码']"
    :activeStep="activeStep"
    @before-next="handleBeforeNext"
    @before-close="handleResetFinish"
    @closed="handleDialogClose"
    >
    <div v-show="verifyWay === 'password'" slot="title" class="cc-title">修改密码</div>
    <DataForm
      ref="passwordForm"
      :model="passwordForm"
      :rules="rules"
      :hide-required-asterisk="true"
      label-width="100px"
      class="demo-ruleForm">
      <template v-if="activeStep === 0">
        <el-form-item label="验证方式" style="margin-bottom: 0" required >
          <el-col :span="8">
            <el-form-item label="" label-width="0">
              <SelectEnum v-model="verifyWay" :clearable="false" :options="verifyOptions" @change="handleChangeVerifyWay"/>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="15">
            <el-form-item label="" label-width="0" :prop="verifyWayField">
              <el-input
                v-show="verifyWay === 'password'"
                v-model="passwordForm.password"
                v-noSpace
                type="password"
                maxlength="45"
                placeholder="请输入旧密码" />
              <el-input
                v-show="verifyWay === 'phone'"
                v-model="passwordForm.phone"
                v-noSpace
                placeholder="请输入手机号" />
              <el-input
                v-show="verifyWay === 'email'"
                v-model="passwordForm.email"
                v-noSpace
                placeholder="请输入邮箱" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <!-- 旧密码 -->
        <template v-if="verifyWay === 'password'">
          <FormString
            label="新密码"
            placeholder="请输入新密码"
            prop="newPassword"
            v-noSpace
            v-model.trim="passwordForm.newPassword"
            maxlength="45"
            type="password" />
          <FormString
            label="密码确认"
            placeholder="请再次输入新密码"
            prop="comPassword"
            v-noSpace
            v-model.trim="passwordForm.comPassword"
            @paste.native.capture.prevent
            maxlength="45"
            type="password" />
        </template>
        <!-- 手机或邮箱 -->
        <template v-else>
          <el-form-item label="验证码" style="margin-bottom: 0" >
            <el-col :span="15">
              <el-form-item label="" label-width="0" prop="verificationCode">
                <el-input maxlength="4" v-model.trim="passwordForm.verificationCode" :placeholder="verificationCodePlaceholder"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="8">
              <el-button
                plain
                v-if="verifyWay === 'phone'"
                style="width:100%"
                :disabled="phoneCode.disabled"
                @click="handleSendCode(phoneCode)">
                {{phoneCode.msg}}
              </el-button>
              <el-button
                v-if="verifyWay === 'email'"
                plain
                style="width:100%"
                :disabled="emailCode.disabled"
                @click="handleSendCode(emailCode)">
                {{emailCode.msg}}
              </el-button>
            </el-col>
          </el-form-item>
        </template>
      </template>
      <template v-else>
        <FormString
          label="新密码"
          placeholder="请输入新密码"
          prop="newPassword"
          v-noSpace
          v-model.trim="passwordForm.newPassword"
          type="password" />
        <FormString
          label="密码确认"
          placeholder="请再次输入新密码"
          prop="comPassword"
          v-noSpace
          v-model.trim="passwordForm.comPassword"
          @paste.native.capture.prevent
          type="password" />
      </template>
    </DataForm>
  </StepTwoDialog>
</template>

<script>
import StepTwoDialog from './StepTwoDialog'
import SelectEnum from '@/components/form/SelectEnum'
import { genInteractionCodeMethods } from './loginAccountUtil'
export default {
  components: {
    StepTwoDialog,
    SelectEnum
  },
  data() {
    var validatorVerificationCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写验证码'))
      } else {
        this.$service
          .checkSmsCode({
            code: value,
            emailOrPhone: this.verifyWay === 'phone' ? this.$encrypt(this.passwordForm.phone) : this.verifyWay === 'email' ? this.$encrypt(this.passwordForm.email) : ''
          })
          .then(data => {
            if (data.isError) {
              callback(new Error('请输入正确验证码'))
            } else {
              callback()
            }
          })
      }
    }
    return {
      activeStep: 0,
      verifyOptions: [
        { label: '旧密码', value: 'password' },
        { label: '手机验证', value: 'phone' },
        { label: '邮箱验证', value: 'email' }
      ],
      passwordForm: this.genPasswordForm(),
      verifyWay: 'password',
      rules: {
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
          // { validator: this.validatorPassword, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { validator: this.validatorPhoneOrEmail, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { validator: this.validatorPhoneOrEmail, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: this.validatorPassword, trigger: 'blur' }
        ],
        comPassword: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: this.validatorPasswordAgain, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validatorVerificationCode, trigger: 'blur' }
          // { len: 4, message: '长度为4个字符', trigger: 'blur' }
        ]
      },
      phoneCode: {
        codeCount: 60,
        msg: '获取验证码',
        timer: null,
        disabled: false
      },
      emailCode: {
        codeCount: 120,
        msg: '获取验证码',
        timer: null,
        disabled: false
      }
    }
  },
  props: {
    account: {
      type: String
    }
  },
  computed: {
    verificationCodePlaceholder() {
      const verifyWay = this.verifyWay
      let way = verifyWay === 'phone' ? '手机' : '邮箱'
      return '请输入' + way + '验证码'
    },
    verifyWayField() {
      const verifyWay = this.verifyWay
      return verifyWay
    }
  },
  methods: {
    genPasswordForm() {
      return {
        password: undefined,
        phone: undefined,
        email: undefined,
        newPassword: undefined,
        comPassword: undefined,
        verificationCode: undefined
      }
    },
    validatorPassword(rule, value, callback) {
      if (/^(?![A-Za-z0-9]+$)(?![A-Za-z\W]+$)(?![0-9\W]+$)[a-zA-Z0-9\W]{8,}$/.test(value)) {
        if (value === this.account) {
          callback(new Error('密码不能与登录账号相同'))
        } else {
          callback()
        }
      } else {
        callback(new Error('必须包含数字、字母及特殊符号，长度不少于8位'))
      }
    },
    validatorPasswordAgain(rule, value, callback) {
      const form = this.passwordForm
      if (form.newPassword === form.comPassword) {
        callback()
      } else {
        callback(new Error('两次输入密码须一致'))
      }
    },
    validatorPhoneOrEmail(rule, value, callback) {
      let phoneError = !/^1(3|4|5|7|8)\d{9}$/.test(value)
      let emailError = !/^([A-z0-9_-]+)@([A-z0-9_-]+)+(\.([A-z0-9_-]+))+$/.test(value)
      if (!phoneError || !emailError) {
        callback()
      } else {
        const type = this.verifyWay
        if (type !== 'phone') {
          callback(new Error('请输入正确的邮箱格式'))
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
    },
    // 发送验证码
    handleSendCode(codeObj) {
      const { verifyWay: type, passwordForm } = this
      const account = type === 'phone' ? this.$encrypt(passwordForm.phone) : this.$encrypt(passwordForm.email)
      const fieldName = type
      const $ref = this.$refs.passwordForm.$refs.form
      $ref.validateField(fieldName, (err) => {
        if (err !== '') {
          return
        }
        genInteractionCodeMethods(codeObj, () => {
          this.$service.sendCode({
            phone: type === 'phone' ? account : undefined,
            email: type !== 'phone' ? account : undefined
          })
        })
      })
    },
    handleBeforeNext() {
      const $ref = this.$refs.passwordForm.$refs.form
      $ref.validateField('verificationCode', (err) => {
        if (err !== '') {
          return
        }
        this.activeStep++
        // const { passwordForm, verifyWay } = this
        // const account = passwordForm[verifyWay]
        // this.activeStep++
        // this.$service.checkSmsCode({
        //   emailOrPhone: account,
        //   code: passwordForm.verificationCode
        // }).then(() => {
        //   this.activeStep++
        // })
      })
    },
    handleResetAccount() {
      this.show.accountDialog = false
    },
    handleChangeVerifyWay() {
      const $ref = this.$refs.passwordForm.$refs.form
      $ref.resetFields()
      const passwordForm = this.genPasswordForm()
      this.passwordForm = passwordForm
    },
    handleResetFinish() {
      const type = this.verifyWay
      const passwordForm = this.cloneDeep(this.passwordForm)
      const $ref = this.$refs.passwordForm.$refs.form
      $ref.validate((valid) => {
        if (!valid) {
          return
        }
        // const smsCode = passwordForm.verificationCode
        let data = {
          newPassword: this.$encrypt(passwordForm.newPassword),
          comPassword: this.$encrypt(passwordForm.comPassword)
        }
        if (type === 'password') {
          data.oldPassword = this.$encrypt(passwordForm.password)
          data.validateType = 0
        } else if (type === 'phone') {
          data.phone = this.$encrypt(passwordForm.phone)
          data.validateType = 1
          data.code = passwordForm.verificationCode
        } else {
          data.email = this.$encrypt(passwordForm.email)
          data.validateType = 2
          data.code = passwordForm.verificationCode
        }
        this.$service.resetPassword(data, '修改成功').then(() => {
          this.$refs.dialog.isVisableDialog = false
          setTimeout(() => {
            this.$service.logout()
            this.$router.push({ name: 'login' })
          }, 4000)
        })
      })
    },
    handleDialogClose() {
      this.$refs.passwordForm.$refs.form.resetFields()
      this.verifyWay = 'password'
      this.phoneCode = {
        codeCount: 60,
        msg: '获取验证码',
        timer: null,
        disabled: false
      }
      this.emailCode = {
        codeCount: 120,
        msg: '获取验证码',
        timer: null,
        disabled: false
      }
      this.activeStep = 0
    }
  },
  created() {

  }
}
</script>

<style lang="stylus" scoped>
.cc-title
  text-align center
  color #ff8b00
  font-size 18px
  font-weight bold
  padding-bottom 15px
.step-title
  text-align center
  color #ff8b00
  font-size 18px
  font-weight bold
  padding-bottom 15px
>>>.el-dialog__body
  padding 0
.demo-ruleForm
  max-width 500px
.demo-ruleForm >>>.el-form-item
  margin-bottom 15px
</style>
